define('newsletter',['jquery'],
function ($) {

    // Subscription
    $('.content1').show();
    $('.content2, .content3, .content4').hide();
    $('.header1').addClass("headerBlue");
    $(".btback2").click(function () {
        $('.content1').show();
        $('.content2, .content3, .content4').hide();
        $('.header1').addClass("headerBlue");
        $('.header2, .header3, .header4').removeClass("headerBlue");
        $('html, body').animate({
            scrollTop: $(".content1").offset().top
        }, 1000);
    });
    $(".btnext1, .btback3").click(function () {

        if ($('.email-field').val().length === 0) {
            $('.email-field').addClass('field-email-error');
            return false;
        }
        else {
            $('.email-field').removeClass('field-email-error');
        }
        var valEmail = $('.email-field').val();
        if (!validateEmail(valEmail)) {
            $('.email-field').addClass('field-email-error');
            return false;
        }
        else {
            $('.email-field').removeClass('field-email-error');
        }

        if ($('.name-field').val().length === 0) {
            $('.name-field').addClass('field-name-error');
            return false;
        }
        else {
            $('.name-field').removeClass('field-name-error');
        }
        consentCheckbox = $("input[name*='consent']");
        var checkboxVal = consentCheckbox[0].checked;
        if (($("input[name*='consent']:checked").length) <= 0) {
            $("input[name*='consent']").addClass('error');
            return false;
        }
        else {
            $("input[name*='consent']").removeClass('error');
        }
        if (!checkboxVal) {
            consentCheckbox.addClass("error");
            return;
        }

        //call service to check if email exists or not
        var _email = $('.email-field');
        var _name = $('.name-field');

        $.ajax({
            type: "GET",
            url: "/api/emailplatform/Index?email=" + _email.val() + "&name=" + _name.val(),
            async: false,
            beforeSend: function (x) {
                if (x && x.overrideMimeType) {
                    x.overrideMimeType("application/j-son;charset=UTF-8");
                }
            },
            dataType: "json",
            success: function (data) {
                if (data.isSubscribed) {
                    $("#dialog-confirm").html("Vil du tilpasse dit nyhedsbrev eller tilføje et abonnement på magasinet Ret & Indsigt?");
                    $("#dialog-confirm").dialog({
                        resizable: false,
                        height: "auto",
                        width: 355,
                        title: "Du er allerede tilmeldt!",
                        modal: true,
                        buttons: {
                            "Ja tak": function () {
                                $(this).dialog("close");
                                $('.content1, .content3, .content4').hide();
                                $('.content2').show();
                                $('.header1, .header3, .header4').removeClass("headerBlue");
                                $('.header2').addClass("headerBlue");
                                $('html, body').animate({ scrollTop: $(".content2").offset().top }, 1000);
                            },
                            "Nej, ikke nu": function () {
                                $(this).dialog("close");
                                return false;
                            }
                        }
                    });
                }
                else {
                    $('.content1, .content3, .content4').hide();
                    $('.content2').show();
                    $('.header1, .header3, .header4').removeClass("headerBlue");
                    $('.header2').addClass("headerBlue");
                    $('html, body').animate({ scrollTop: $(".content2").offset().top }, 1000);
                }
            },
            error: function (data) {
                console.log("Data Error", data);
                return false;
            }
        });

    });

    $(".btnext2, .btback4").click(function () {
        $('.content1, .content2, .content4').hide();
        $('.content3').show();
        $('.header1, .header2, .header4').removeClass("headerBlue");
        $('.header3').addClass("headerBlue");
        $('html, body').animate({
            scrollTop: $(".content3").offset().top
        }, 1000);
    });
    $(".btnext3").click(function () {

        if ($(".trykt").is(':checked')) {
            if ($('.txtFormName').val() === '' || $('.txtFormTitle').val() === '' || $('.txtFormOrganisation').val() === '' || $('.txtFormAddress').val() === '' || $('.txtFormPostcode').val() === '' || $('.txtFormCountry').val() === '') {
                $('.field-print-error').removeClass('unvisible');
                return false;
            }
            else {
                $('.field-print-error').addClass('unvisible');
            }
        }

        $('.content1, .content2, .content3').hide();
        $('.content4').show();
        $('.header1, .header2, .header3').removeClass("headerBlue");
        $('.header4').addClass("headerBlue");
        $('html, body').animate({
            scrollTop: $(".content4").offset().top
        }, 1000);
    });
    $('.trykt').click(function () {
        if ($(this).is(":checked")) {
            $('.magasin_form').fadeIn(1000);
        } else {
            $('.magasin_form').fadeOut(1000);
        }
    });
    if ($('.trykt').is(":checked")) {
        $('.magasin_form').show();
    }
    $(".btnav").hover(function () {
        $(this).toggleClass("mouseover");
    });
    $(".btnavSend").hover(function () {
        $(this).toggleClass("mouseover");
    });
    $(".btSend").click(function () {
        if (grecaptcha && grecaptcha.getResponse().length !== 0) {

        }
        else {
            $(".captcha__check").show();
            return false;
        }

    });

    // Unsubscription
    $(".cbnewsletter").change(function () {
        if (this.checked) {
            $(".cbmagasin").prop('checked', true);
            $(".cbmagasin").prop('disabled', true);
        }
        else {
            $(".cbmagasin").prop('checked', false);
            $(".cbmagasin").prop('disabled', false);
        }
    });
    
    $(".btSend2").click(function () {
        var valEmail2 = $('.email-field2').val();
        if (!validateEmail(valEmail2) || valEmail2.length === 0) {
            $('.email-field2').addClass('field-email-error');
            return false;
        }
        else {
            $('.email-field2').removeClass('field-email-error');
        }
    });
    $(".email-field2").focus(function () {
        $('.email-field2').removeClass('field-email-error');
    });
    $(".email-field").focus(function () {
        $('.email-field').removeClass('field-email-error');
    });
    $(".name-field").focus(function () {
        $('.name-field').removeClass('field-name-error');
    });
    // Functions
    function validateEmail($email) {
        //var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        var emailReg = new RegExp(/^(("[\w+\-\s]+")|([\w+\-]+(?:\.[\w+\-]+)*)|("[\w+\-\s]+")([\w+\-]+(?:\.[\w+\-]+)*))(@((?:[\w\-]+\.)*\w[\w\-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        return emailReg.test($email);
    }


    // API call to update profiles
    var $updateProfile = $('.form-update-profile');
    var apiUrl = '/api/UpdateProfile/index';

    $updateProfile.on('submit', function (e) {
        e.preventDefault();

        $('button').removeClass('green');
        $('button').removeClass('red');
        $('.spinning').show();
        $responseContainer = $('.unsubscribe__response');
        var emailInput = $('.emailinput').val();
        $responseContainer.empty();

        $.ajax({
            url: "/api/UpdateProfile/index?email=" + emailInput,
            type: 'GET',
            success: function (response) {
                $responseContainer.html(response.replace("\n", "<br/>").replace("\n", "<br/>").replace("\n", "<br/>"));
                $('.spinning').hide();
                $('button').addClass('green');
            },
            error: function (response) {
                $responseContainer.html(response.statusText);
                $('.spinning').hide();
                $('button').addClass('red');
            }
        });
    });

});

